<div class="bg-m0 flex select-none flex-col p-9">
  <div
    data-cy="editNameDialogTitle"
    class="text-s2 mt-5 flex-grow text-left text-2xl font-semibold"
    >Edit Name</div
  >

  <form
    class="flex w-80 flex-col"
    [formGroup]="editNameForm"
    (ngSubmit)="save()"
  >
    <input
      autocomplete="off"
      spellcheck="false"
      data-cy="editNameDialogFirstNameInput"
      class="form-input border-s3 focus:border-m600 mt-9 rounded"
      [ngClass]="{
        'border-r600':
          editNameForm.controls['firstName'].invalid &&
          editNameForm.controls['firstName'].touched
      }"
      formControlName="firstName"
      placeholder="First Name"
    />
    <m-validation [control]="editNameForm.controls['firstName']"></m-validation>

    <input
      autocomplete="off"
      spellcheck="false"
      data-cy="editNameDialogLastNameInput"
      class="form-input border-s3 focus:border-m600 mt-1 rounded"
      [ngClass]="{
        'border-r600':
          editNameForm.controls['lastName'].invalid &&
          editNameForm.controls['lastName'].touched
      }"
      formControlName="lastName"
      placeholder="Last Name"
    />
    <m-validation [control]="editNameForm.controls['lastName']"></m-validation>

    <div class="mt-6">
      <button
        data-cy="editNameDialogSaveButton"
        class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
        type="submit"
        >Save</button
      >

      <button
        data-cy="editNameDialogCancelButton"
        class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
        type="button"
        (click)="cancel()"
        >Cancel</button
      >
    </div>
  </form>
</div>
